export default {"src":"/_next/static/media/QS.286193c3.svg","height":18,"width":18};